import { render, staticRenderFns } from "./AudioUploader.vue?vue&type=template&id=6400836b&scoped=true&"
import script from "./AudioUploader.vue?vue&type=script&lang=js&"
export * from "./AudioUploader.vue?vue&type=script&lang=js&"
import style0 from "./AudioUploader.vue?vue&type=style&index=0&id=6400836b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6400836b",
  null
  
)

export default component.exports